// admin/src/components/ProgramCardPro.jsx
import React from 'react';

export default function ProgramCardPro({ program, onEdit, onDelete }) {
  const img = program?.image || '';
  
  // Format degree level tag for display
  const formatDegreeLevel = (slug) => {
    const map = {
      'bachelors': "Bachelor's",
      'masters': "Master's",
      'phd': 'Ph.D.',
      'associate': "Associate's",
      'certificate': 'Certificate',
      'other': 'Other'
    };
    return map[slug] || slug.charAt(0).toUpperCase() + slug.slice(1);
  };

  return (
    <article className="adm-card">
      <div className="adm-card__header">
        {img ? (
          <img
            className="adm-thumb"
            src={img}
            alt={program.title}
            loading="lazy"
            width="240"
            height="160"
            onError={(e)=>{ e.currentTarget.style.visibility='hidden'; }}
          />
        ) : (
          <div className="adm-thumb adm-thumb--empty">No Image</div>
        )}
        <div className="adm-card__headtext">
          <div className="adm-title">{program.title || 'Untitled'}</div>
          {program.permalink ? (
            <div className="adm-sub">
              <a
                className="adm-sub__url"
                href={program.permalink}
                target="_blank"
                rel="noreferrer"
                title={program.permalink}
              >
                {program.permalink}
              </a>
            </div>
          ) : <div className="adm-sub adm-empty">No permalink</div>}
        </div>
      </div>

      <div className="adm-card__body">
        <div className="adm-badgerow">
          <span className={`adm-badge ${program.enabled ? 'adm-badge--success' : 'adm-badge--muted'}`}>
            {program.enabled ? 'Enabled' : 'Disabled'}
          </span>
          <span className="adm-badge adm-badge--neutral">ID: {program._id?.slice(-6) || '—'}</span>
        </div>

        {/* Degree Level Tags */}
        {program.degreeLevelTags && program.degreeLevelTags.length > 0 && (
          <div className="adm-section">
            <div className="adm-section__title">🎓 Degree Levels</div>
            <div className="adm-badgerow">
              {program.degreeLevelTags.map((level, idx) => (
                <span 
                  key={idx}
                  className="adm-badge"
                  style={{
                    background: '#dbeafe',
                    color: '#1e40af',
                    border: '1px solid #93c5fd',
                    fontWeight: 600
                  }}
                  title={`${formatDegreeLevel(level)} program`}
                >
                  🎓 {formatDegreeLevel(level)}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Areas of Study */}
        <div className="adm-section">
          <div className="adm-section__title">📚 Areas of Study</div>
          <div className="adm-pillrow">
            {(program.areasOfStudy || []).slice(0, 6).map((a, i) => (
              <span key={i} className="adm-tag">{a}</span>
            ))}
            {Array.isArray(program.areasOfStudy) && program.areasOfStudy.length > 6 && (
              <span className="adm-more">+{program.areasOfStudy.length - 6} more</span>
            )}
            {(!program.areasOfStudy || program.areasOfStudy.length === 0) && (
              <span className="adm-empty">No areas tagged yet</span>
            )}
          </div>
        </div>

        {/* Warning if no degree levels set */}
        {(!program.degreeLevelTags || program.degreeLevelTags.length === 0) && (
          <div style={{
            padding: '8px 12px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: 6,
            fontSize: '0.8rem',
            color: '#dc2626',
            marginTop: 8
          }}>
            ⚠️ No degree levels set - won't appear in degree-filtered searches
          </div>
        )}

        <div className="adm-actions">
          <button className="btn btn--ghost" onClick={onEdit}>Edit</button>
          <button className="btn btn--danger" onClick={onDelete}>Delete</button>
        </div>
      </div>
    </article>
  );
}